// extracted by mini-css-extract-plugin
module.exports = {"content":"Content--content--2tc1k","placeholderAnim":"Content--placeholderAnim--2uN2W"};